import type { SVGProps } from 'react';
export const Columns = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M4.15 4.15v11.7h1.91V4.14zm-.9-.75C3.4 3.2 3.66 3 4 3H6.2c.34 0 .6.19.77.4q.24.34.24.76v11.68q0 .43-.24.76a1 1 0 0 1-.77.4H4a1 1 0 0 1-.77-.4 1.3 1.3 0 0 1-.24-.76V4.16q0-.43.24-.76m5.8.75v11.7h1.9V4.14zm-.91-.75c.16-.21.42-.4.77-.4h2.18c.35 0 .61.19.77.4q.24.34.24.76v11.68q0 .43-.24.76a1 1 0 0 1-.77.4H8.91a1 1 0 0 1-.77-.4 1.3 1.3 0 0 1-.24-.76V4.16q0-.43.24-.76m5.8.75v11.7h1.91V4.14zm-.9-.75c.16-.21.42-.4.76-.4H16c.34 0 .6.19.77.4q.24.34.24.76v11.68q0 .43-.24.76a1 1 0 0 1-.77.4H13.8a1 1 0 0 1-.77-.4 1.3 1.3 0 0 1-.24-.76V4.16q0-.43.24-.76"
      clipRule="evenodd"
    />
  </svg>
);
